import { render, staticRenderFns } from "./openOrders.vue?vue&type=template&id=c70eeec0&"
import script from "./openOrders.vue?vue&type=script&lang=js&"
export * from "./openOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports